import RegistrationOnlyAlert from '../../../components/FormAlerts/RegistrationOnlyAlert';
import DisabilityConfirmationPage from '../../../components/FormPages/DisabilityConfirmation';
import CompensationTypeReviewPage from '../../../components/FormReview/CompensationTypeReviewPage';
import { emptyObjectSchema } from '../../../definitions';
import {
  hasHighCompensation,
  hasLowDisabilityRating,
  hasNoCompensation,
  includeRegOnlyGuestQuestions,
  showRegOnlyGuestConfirmation,
} from '../../../utils/helpers';
import benefitsPackage from './benefitsPackage';
import compensationType from './compensationType';
import pensionInformation from './pensionInformation';

export const vaBenefitsPages = {
  benefitsCompensationType: {
    path: 'va-benefits/basic-information',
    title: 'VA benefits',
    depends: hasLowDisabilityRating,
    CustomPageReview: CompensationTypeReviewPage,
    ...compensationType,
  },
  benefitsPackage: {
    path: 'va-benefits/benefits-package',
    title: 'VA benefits package',
    depends: includeRegOnlyGuestQuestions,
    CustomPageReview: null,
    ...benefitsPackage,
  },
  benefitsConnectedCare: {
    path: 'va-benefits/service-connected-care',
    title: 'Care for service-connected conditions',
    depends: showRegOnlyGuestConfirmation,
    CustomPage: RegistrationOnlyAlert,
    CustomPageReview: null,
    uiSchema: {},
    schema: emptyObjectSchema,
  },
  benefitsDisabilityConfirmation: {
    path: 'va-benefits/confirm-service-pay',
    title: 'Disability confirmation',
    depends: hasHighCompensation,
    CustomPage: DisabilityConfirmationPage,
    CustomPageReview: null,
    uiSchema: {},
    schema: emptyObjectSchema,
  },
  benefitsPensionType: {
    path: 'va-benefits/pension-information',
    title: 'VA pension',
    depends: hasNoCompensation,
    ...pensionInformation,
  },
};
